export const baseStyles = (isActive: boolean) => [
	"inline-flex",
	"items-center",
	"justify-center",
	isActive ? "bg-button-normal-primary-default" : "bg-button-normal-secondary-default",
];

export const hoverStyles = (isActive: boolean) => [
	isActive ? "hover:bg-button-normal-primary-hover" : "hover:bg-button-normal-secondary-hover",
];
export const iconStyles = (isActive: boolean) =>
	isActive
		? [
				"[&_svg]:fill-icon-fixed-light-default",
				"[&:hover_svg]:fill-icon-fixed-light-hover",
				"[&:focus_svg]:fill-icon-fixed-light-focus",
				"[&:active_svg]:fill-icon-fixed-light-active",
			]
		: [
				"[&_svg]:fill-text-primary",
				"[&:hover_svg]:fill-text-primary",
				"[&:focus_svg]:fill-text-primary",
				"[&:active_svg]:fill-icon-active",
			];

export const disabledStyles = (isActive: boolean, isDisabled: boolean) =>
	isDisabled && [
		"cursor-not-allowed",
		isActive ? "[&_svg]:fill-icon-inverse-disabled" : "[&_svg]:fill-icon-disabled",
	];
